import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { LogoMark } from '@/components/generals/logo'

const FOOTER_LINKS = [
    { href: '/faq', label: 'راهنما و پرسش‌ها' },
    { href: '/knowledge/confluence-knowledge-training', label: 'آموزش ثبت دانش' },
    { href: '/design-system', label: 'سیستم طراحی' },
    { href: '/implementation', label: 'نقشه پیاده‌سازی در Confluence' }
]

export const Footer: FC = (): ReactNode => {
    return (
        <footer className='border-t border-border bg-card'>
            <div className='mx-auto flex max-w-[1240px] flex-col gap-5 px-4 py-6 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8'>
                <div className='flex items-center gap-3'>
                    <LogoMark className='size-8' />

                    <div className='flex flex-col'>
                        <p className='text-sm font-bold text-navy'>سامانه مدیریت دانش بهسازان ملت</p>
                        <p className='text-caption text-muted-foreground'>بر بستر Atlassian Confluence</p>
                    </div>
                </div>

                <nav aria-label='پیوندهای پایین صفحه'>
                    <ul className='flex flex-wrap gap-x-5 gap-y-2'>
                        {FOOTER_LINKS.map(link => (
                            <li key={link.href}>
                                <Link
                                    href={link.href}
                                    className='rounded-sm text-small text-muted-foreground transition-colors hover:text-primary-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/45'
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <p className='text-caption text-muted-foreground'>
                    © ۱۴۰۵ شرکت بهسازان ملت
                </p>
            </div>
        </footer>
    )
}
